/**
 * MD3 Corner Radius Token Scale.
 * Ported from MD3 spec: https://m3.material.io/styles/shape/corner-radius-scale
 *
 * The Material 3 shape system uses a 10-step size-based scale.
 * All values are in density-independent pixels (dp).
 *
 * @example
 * import { MD3CornerRadius } from "@bug-on/m3-expressive";
 *
 * // Use a token name
 * const rounding = { radius: MD3CornerRadius.large, smoothing: 0 };
 *
 * // Use with ShapeMedia
 * <ShapeMedia shape="pill" cornerRadius="extraLarge" ... />
 */
export const MD3CornerRadius = {
	/** 0dp — Sharp corners */
	none: 0,
	/** 4dp */
	extraSmall: 4,
	/** 8dp */
	small: 8,
	/** 12dp */
	medium: 12,
	/** 16dp */
	large: 16,
	/** 20dp (new in M3 Expressive) */
	largeIncreased: 20,
	/** 28dp */
	extraLarge: 28,
	/** 32dp (new in M3 Expressive) */
	extraLargeIncreased: 32,
	/** 48dp (new in M3 Expressive) */
	extraExtraLarge: 48,
	/** 9999dp — Fully rounded (pill/circle) */
	full: 9999,
} as const;

/** Token name for MD3 corner radius scale. */
export type MD3CornerRadiusToken = keyof typeof MD3CornerRadius;
